import axios from "axios";

export const rr = axios.create({
  baseURL: "https://runrun.it/api/v1.0/",
});
